import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting to enable real time terms open with faire
 * https://www.notion.so/faire/Real-Time-OWF-Decisioning-1c82efb5c25a801cb3bce02d515f74e8?source=copy_link
 */
export const REAL_TIME_TERMS_OWF_250618 =
  'REAL_TIME_TERMS_OWF_250618' as SettingConst<
    'REAL_TIME_TERMS_OWF_250618',
    boolean,
    'RETAILER' | 'VISITOR_WEB' | 'HOTJAR_RETAILER'
  >;
